export var eqconsts;
(function (eqconsts) {
    /**
     * Defines some commonly used constants
     */
    var ConstLists = /** @class */ (function () {
        function ConstLists() {
            /**
             * Contains macros for the special dates (like Today, First day of the month, etc)
             */
            this.SpecDateValues = [
                { id: '${Today}', key: 'Today', isDefault: true },
                { id: '${Yesterday}', key: 'Yesterday' },
                { id: '${Tomorrow}', key: 'Tomorrow' },
                { id: '${FirstDayOfMonth}', key: 'FirstDayOfMonth' },
                { id: '${FirstDayOfYear}', key: 'FirstDayOfYear' }
            ];
            /**
             * Contains macros for the special times (like Now, Noon, etc)
             */
            this.SpecTimeValues = [
                { id: '${Now}', key: 'Now', isDefault: true },
                { id: '${HourStart}', key: 'HourStart' },
                { id: '${Midnight}', key: 'Midnight' },
                { id: '${Noon}', key: 'Noon' }
            ];
            /**
             * Boolean values macros (true and false)
             */
            this.BooleanValues = [
                { id: '${false}', key: 'False' },
                { id: '${true}', key: 'True', isDefault: true }
            ];
        }
        return ConstLists;
    }());
    /**
     * Contains some constants (macros) with special date/time and boolean values.
     */
    eqconsts.constLists = new ConstLists();
    /**
     * Constants representing various types of relationships between conditions
     */
    eqconsts.predicateLinkTypeList = [
        { id: 'All', key: 'LinkTypeAll' },
        { id: 'Any', key: 'LinkTypeAny' },
        { id: 'None', key: 'LinkTypeNone' },
        { id: 'NotAll', key: 'LinkTypeNotAll' }
    ];
})(eqconsts || (eqconsts = {}));
//# sourceMappingURL=constants.js.map